export const LABELS = {
  contactMail: 'info@mZaednica.mk',
  supportMail: 'support@mZaednica.mk',
}
